import React, { useEffect } from "react";
import { Button, Spin, message } from "antd";
import { Subevent, useSubevents } from "../data/Subevents";
import SubeventCard from "./components/SubeventCard";
import { usePrebookingResponse } from "../data/PrebookingResponse";
import PreBookingInfo from "./components/PreBookingInfo";
import { useNavigate } from "react-router-dom";
import { Row, Col, Container, Hidden } from "react-grid-system";
import { RightOutlined, LeftOutlined } from "@ant-design/icons";
import dayjs from "dayjs";
import "dayjs/locale/de"
import { useEvent } from "../data/Event";
dayjs.locale('de')

interface IndividualBookingProps {
    messageApi: ReturnType<typeof message.useMessage>[0];
}

function IndividualBooking(props: IndividualBookingProps) {
    const subevents = useSubevents(state => state.subevents);
    const fetchAndSetSubevents = useSubevents(state => state.fetchAndSetSubevents);
    const prebookingResponse = usePrebookingResponse(state => state.prebookingResponse);
    const subeventsLoading = useSubevents(state => state.loading);
    const [subeventsByDate, setSubeventsByDate] = React.useState({} as { [date: string]: Subevent[] });
    const [numberOfDates, setNumberOfDates] = React.useState(0);
    const navigate = useNavigate();
    const event = useEvent(state => state.event);


    useEffect(() => {
        fetchAndSetSubevents(event?.id ?? 0, () => {
            props.messageApi.error("Error trying to load passes.");
        });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        const subeventsByDate = subevents.reduce((acc, subevent) => {
            acc[subevent.date] = acc[subevent.date] ?? [];
            acc[subevent.date].push(subevent);
            return acc;
        }, {} as { [date: string]: Subevent[] });
        setSubeventsByDate(subeventsByDate);
        setNumberOfDates(Object.keys(subeventsByDate).length);
    }, [subevents]);

    return (
        <Container>
            <Row gutterWidth={20}>
                <Col sm={12} xl={8} xxl={8} style={{ marginTop: "20px" }}>
                    <div style={{
                        backgroundColor: "white", borderRadius: "10px", padding: "20px",
                        boxShadow: "0px 0px 20px 10px rgba(0,0,0,.1)",
                        minHeight: "700px"
                    }}>
                        <Hidden xs sm>
                            <h1 style={{ textAlign: "left", marginTop: 0, color: "black", marginBottom: 0 }}>Choose your pass</h1>
                        </Hidden>
                        <Hidden md lg xl xxl xxxl>
                            <h1 style={{ textAlign: "center", marginTop: 0, color: "black", marginBottom: 0 }}>Choose your pass</h1>
                        </Hidden>
                        <div style={{ textAlign: "left", marginTop: "8px" }}>
                            {event?.description.split("\n").map((line, index) => (
                                <p key={index} style={{ margin: 0 }}>{line}</p>
                            ))}
                        </div>
                        <Row gutterWidth={30}>
                            {subeventsLoading ? <Spin size="large" style={{ position: "absolute", top: "50%", left: "50%", transform: "translate(-50%, -50%)" }} /> :
                                subeventsByDate && Object.keys(subeventsByDate).map(date => (
                                    <>
                                        <Col xxxl={Math.max(4, 12 / numberOfDates)}
                                            xxl={Math.max(4, 12 / numberOfDates)}
                                            xl={Math.max(6, 12 / numberOfDates)}
                                            md={Math.max(6, 12 / numberOfDates)}
                                            sm={Math.max(12, 12 / numberOfDates)}
                                            xs={12}
                                            style={{}}
                                        >
                                            {subeventsByDate[date].sort(
                                            ).map(subevent => (
                                                <SubeventCard style={{ marginTop: "20px" }} subevent={subevent} messageApi={props.messageApi} />
                                            ))}
                                        </Col>
                                    </>
                                ))
                            }
                        </Row>
                    </div>
                </Col>
                <Col sm={12} xl={4} xxl={4} style={{ marginTop: "20px" }}>
                    <div style={{
                        backgroundColor: "white", borderRadius: "10px", padding: "20px",
                        boxShadow: "0px 0px 20px 10px rgba(0,0,0,.1)", minHeight: "700px"
                    }}>
                        <h1 style={{ textAlign: "center", marginTop: 0, color: "black" }}>Your selection</h1>
                        <p>Here you can see the price breakdown for you and your partners. Each partner will receive a separate invoice.</p>
                        {(prebookingResponse?.subevents.length ?? 0) > 0 ? <div>
                            <PreBookingInfo />
                        </div> : null
                        }
                    </div>
                </Col>
            </Row>
            <Row style={{ marginTop: "20px", clear: "both" }} gutterWidth={20}>
                <Col xl={12} style={{ marginTop: "20px", clear: "both" }}>
                    <Button size="large" type="primary" onClick={() => navigate(-1)} style={{ float: "left" }}><LeftOutlined />Back</Button>
                    <Button size="large" type="primary" onClick={() => navigate("/confirm")} style={{ float: "right" }}
                        disabled={(prebookingResponse?.subevents.length ?? 0) === 0}>Next <RightOutlined /></Button>
                </Col>
            </Row>
        </Container >
    );
}

export default IndividualBooking;